/**
 * @generated SignedSource<<79d69e04b182b418810ea29d964b2d1d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type sortSCardMutation$variables = {
  backLang?: string | null;
  id: string;
  sortAfterId?: string | null;
};
export type sortSCardMutation$data = {
  readonly sortSCard: {
    readonly sCards: ReadonlyArray<{
      readonly back: {
        readonly translated: boolean | null;
        readonly value: string;
      } | null;
      readonly front: string;
      readonly hint: string | null;
      readonly id: string;
    }>;
  };
};
export type sortSCardMutation = {
  response: sortSCardMutation$data;
  variables: sortSCardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "backLang"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sortAfterId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  },
  {
    "kind": "Variable",
    "name": "sortAfterId",
    "variableName": "sortAfterId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "backLang",
    "variableName": "backLang"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "front",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hint",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "translated",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "sortSCardMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Source",
        "kind": "LinkedField",
        "name": "sortSCard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "SCard",
            "kind": "LinkedField",
            "name": "sCards",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SCardBack",
                "kind": "LinkedField",
                "name": "back",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "sortSCardMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "Source",
        "kind": "LinkedField",
        "name": "sortSCard",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v4/*: any*/),
            "concreteType": "SCard",
            "kind": "LinkedField",
            "name": "sCards",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "SCardBack",
                "kind": "LinkedField",
                "name": "back",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ccd9a960f2f343a4513a8998f4dfdd41",
    "id": null,
    "metadata": {},
    "name": "sortSCardMutation",
    "operationKind": "mutation",
    "text": "mutation sortSCardMutation(\n  $id: ID!\n  $sortAfterId: ID\n  $backLang: String\n) {\n  sortSCard(id: $id, sortAfterId: $sortAfterId) {\n    sCards(backLang: $backLang) {\n      id\n      front\n      hint\n      back {\n        value\n        translated\n        id\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "da0bf5e17cff0e616a19ec8332061889";

export default node;
